import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function Qualification() {
  return <Section background="light" data-id="element-305">
      <FadeIn data-id="element-306">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-307">
          {/* Para quién es */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#1B4332]" data-id="element-308">
            <h3 className="text-xl font-bold mb-6 text-[#1B4332]" data-id="element-309">
              Es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-310">
              {['Te molesta caminar y al día siguiente lo sentís', 'Sentís rigidez al levantarte', 'Las escaleras te exigen demasiado', 'Querés algo simple, sin gimnasio'].map((item, i) => <li key={i} className="flex items-start" data-id="element-311">
                  <Check className="h-5 w-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-312" />
                  <span className="text-gray-700" data-id="element-313">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Para quién NO es */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-gray-300 opacity-90" data-id="element-314">
            <h3 className="text-xl font-bold mb-6 text-gray-700" data-id="element-315">
              No es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-316">
              {['Tuviste lesión reciente con hinchazón fuerte o no podés apoyar', 'Tenés bloqueo articular o dolor nocturno severo', 'Estás con protocolo postoperatorio específico'].map((item, i) => <li key={i} className="flex items-start" data-id="element-317">
                  <X className="h-5 w-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-318" />
                  <span className="text-gray-600" data-id="element-319">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </FadeIn>
    </Section>;
}